<template lang="html">
  <div class="d-flex justify-content-center align-items-center text-primary h2 w-100 loading-section">
    <span class="spinner"></span>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.loading-section{
  height: 300px;
}
.loading-section .spinner{
  width: 50px;
  height: 50px;
  border:4px solid transparent;
  border-left-color: var(--main-color);
  border-radius: 50%;
  animation: spin .4s linear infinite
}
@keyframes spin {
  100%{transform: rotate(360deg);}
}
</style>
